<mat-card appearance="outlined">
  <form novalidate
    [itfgPermissions]="['USER_WRITE']"
    [formGroup]="personalDataForm">
    <mat-card-title>
      <div  flex layout="row" layout-align="space-between center">
        <span class="edit-screen-card-title"
        [translate]="'clients.personalData'">Personal data</span>
        @if (client && client.id) {
          <itfg-kyc-state [client]="client"></itfg-kyc-state>
        }

      </div>
    </mat-card-title>
    <mat-card-content class="remove-mat-form-field-wrapper">
      <div layout="column">
        <div flex
             layout="row"
      layout-wrap
      layout-align="space-between center">
      <mat-form-field flex>
        <input matInput
          itfgTrimInput
          id="civilId"
          [readonly]="civilIdReadonly"
          type="text"
          formControlName="civilId"
          #civilId
          placeholder="{{ 'global.personalId' | translate }}" />
          <mat-label>{{ 'global.personalId' | translate }}</mat-label>
          <div matSuffix
            layout="row"
            layout-align="center center">
            <span
              matTooltip="{{ 'clients.underagedWarningMessage' | translate }}"
              matTooltipPosition="left"
              [matTooltipDisabled]="!civilIdAge || !isUnderaged"
              [ngClass]="{ 'underaged': civilIdAge && isUnderaged }" >
              {{(civilIdGender && civilId.value) ? ((('global.' + civilIdGender + 'Short') | translate) + ' / ') :
              ''}}{{(civilIdAge && civilId.value) ? (civilIdAge + ' ' + (('global.ageShort') | translate)):
            ''}}</span>
            @if (
              personalDataForm.get('civilId').hasError('onlyNumbers') ||
              personalDataForm.get('civilId').hasError('minlength') ||
              personalDataForm.get('civilId').hasError('maxlength') ||
              personalDataForm.get('civilId').hasError('incorrectEgnFormat') ||
              (personalDataForm.get('civilId').touched && personalDataForm.get('civilId').hasError('required'))) {
              <mat-error
                [translate]="'clients.invalidCivilId'">Invalid civil id
              </mat-error>
            }
            @if (!civilIdIsInBlacklist) {
              <button flex
                type="button"
                mat-icon-button
                matTooltip="{{ 'clients.addCivilIdToBlacklist' | translate }}"
                [matTooltipDisabled]="isNewItem"
                matTooltipPosition="above"
                [disabled]="isNewItem || (['BLACKLIST_READ'] | isUnauthorized | async)"
                class="input-suffix-button add-toblacklist-flag-color"
                (click)="addToBlacklist()">
                <mat-icon>not_interested
                </mat-icon>
              </button>
            }
            @if (civilIdIsInBlacklist) {
              <button flex
                type="button"
                mat-icon-button
                [disabled]="isNewItem || (['BLACKLIST_READ'] | isUnauthorized | async)"
                (click)="editInBlacklist()"
                class="input-suffix-button blacklisted-flag-color">
                <mat-icon matTooltip="{{ 'clients.editCivilIdInBlacklist' | translate }}"
                  [matTooltipDisabled]="isNewItem"
                  matTooltipPosition="above">not_interested
                </mat-icon>
              </button>
            }
          </div>
        </mat-form-field>
      </div>
      <mat-form-field>
        <input matInput
          itfgTrimInput
          type="text"
          formControlName="firstName"
          placeholder="{{ 'users.firstName' | translate }}" />
          <mat-label>{{ 'users.firstName' | translate }}</mat-label>
          @if (personalDataForm.get('firstName').hasError('maxlength')) {
            <mat-error
              [translate]="'forms.maxLength'"
              [translateParams]="{value: namesValidation.maxLength}">Max value error
            </mat-error>
          }
          @if (personalDataForm.get('firstName').hasError('lacksLatin')) {
            <mat-error [translate]="'forms.lacksLatin'">
              Latin characters are not allowed
            </mat-error>
          }
        </mat-form-field>
        <mat-form-field>
          <input matInput
            itfgTrimInput
            type="text"
            formControlName="middleName"
            placeholder="{{ 'users.middleName' | translate }}"
            flex="50" />
            <mat-label>{{ 'users.middleName' | translate }}</mat-label>
            @if (personalDataForm.get('middleName').hasError('maxlength')) {
              <mat-error
                [translate]="'forms.maxLength'"
                [translateParams]="{value: namesValidation.maxLength}">Max value error
              </mat-error>
            }
            @if (personalDataForm.get('middleName').hasError('lacksLatin')) {
              <mat-error [translate]="'forms.lacksLatin'">
                Latin characters are not allowed
              </mat-error>
            }
          </mat-form-field>
          <mat-form-field>
            <input matInput
              itfgTrimInput
              type="text"
              formControlName="lastName"
              placeholder="{{ 'users.lastName' | translate }}" />
              <mat-label>{{ 'users.lastName' | translate }}</mat-label>
              @if (personalDataForm.get('lastName').hasError('maxlength')) {
                <mat-error
                  [translate]="'forms.maxLength'"
                  [translateParams]="{value: namesValidation.maxLength}">Max value error
                </mat-error>
              }
              @if (personalDataForm.get('lastName').hasError('lacksLatin')) {
                <mat-error [translate]="'forms.lacksLatin'">
                  Latin characters are not allowed
                </mat-error>
              }
            </mat-form-field>
            <div flex="100"
              layout="row"
              layout-wrap
              layout-align="space-between center">
              <mat-form-field flex>
                <input matInput
                  type="text"
                  formControlName="nationality"
                  [matAutocomplete]="nationality"
                  itfgSelectFirstAutocompleteOptionOnBlur
                  [value]=""
                  placeholder="{{ 'global.citizenship' | translate }}" />
                  <mat-label>{{ 'global.citizenship' | translate }}</mat-label>
                  @if (personalDataForm.get('nationality')?.hasError('lacksLatin')) {
                    <mat-error
                    [translate]="'forms.fieldShouldNotHaveLatinCharacters'"></mat-error>
                  }
                  @if (personalDataForm.get('nationality')?.hasError('notValidCountry') && !(personalDataForm.get('nationality')?.hasError('lacksLatin'))) {
                    <mat-error
                    [translate]="'forms.notValidCountry'"></mat-error>
                  }
                  <mat-autocomplete #nationality="matAutocomplete"
                    itfgHighlightFirstAutocompleteOptionOnChange
                    [displayWith]="mapCountryToDisplayValue">
                    @for (nationality of filteredCountries | async; track nationality) {
                      <mat-option
                        [value]="nationality">
                        {{ nationality.name }}
                      </mat-option>
                    }
                  </mat-autocomplete>
                </mat-form-field>
                <mat-form-field flex>
                  <input matInput
                    type="text"
                    formControlName="secondNationality"
                    [matAutocomplete]="secondNationality"
                    itfgSelectFirstAutocompleteOptionOnBlur
                    [value]=""
                    placeholder="{{ 'global.secondCitizenship' | translate }}" />
                    <mat-label>{{ 'global.secondCitizenship' | translate }}</mat-label>
                    @if (personalDataForm.get('secondNationality')?.hasError('lacksLatin')) {
                      <mat-error
                      [translate]="'forms.fieldShouldNotHaveLatinCharacters'"></mat-error>
                    }
                    @if (personalDataForm.get('secondNationality')?.hasError('notValidCountry') && !(personalDataForm.get('nationality')?.hasError('lacksLatin'))) {
                      <mat-error
                      [translate]="'forms.notValidCountry'"></mat-error>
                    }
                    <mat-autocomplete #secondNationality="matAutocomplete"
                      itfgHighlightFirstAutocompleteOptionOnChange
                      [displayWith]="mapCountryToDisplayValue">
                      @for (nationality of filteredSecondCountryList | async; track nationality) {
                        <mat-option
                          [value]="nationality">
                          {{ nationality.name }}
                        </mat-option>
                      }
                    </mat-autocomplete>
                  </mat-form-field>
                </div>
                <mat-form-field>
                  <mat-label>{{ 'clients.maritalStatus' | translate }}</mat-label>
                  <mat-select matInput
                    formControlName="maritalStatus"
                    disableOptionCentering="true"
                    [compareWith]="compareItemsById"
                    placeholder="{{ 'identityReports.maritalStatus.name' | translate }}">
                    @for (status of maritalStatuses; track status) {
                      <mat-option [disabled]="(['USER_WRITE'] | isUnauthorized | async)"
                        [value]="status">{{ status.name }}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>
            </mat-card-content>
          </form>
        </mat-card>
